/** Extension points of the AI-change detail page (`/ai-changes/:id`).
 *
 *  A3c ships the page read-and-revert only. A8 (MCP editing, M24 rev 3) adds, here rather than
 *  inside `AIChangeDetailPage`:
 *
 *  - the **pending MCP revert requests** of the change set — a production tenant's MCP `revert` waits
 *    for a person holding `console_notification_mcp_write`, who applies or rejects it on this page;
 *  - the **MCP request** a human applied to produce this change set, when it came from one.
 *
 *  An apply request is reviewed on its proposal's page (`/ai-changes/proposals/:id`), which carries
 *  the real-booking before → after renders.
 *
 *  Both receive the change set as the page loaded it and own their queries, permissions and
 *  empty state: an extension that has nothing to say for a change set renders nothing. The
 *  backend stays the authority on what the operator may do. */
import type { ComponentType } from 'react';

import type { AIChangeDetail } from '@/api/aiChanges';

import { PendingRequestsSection } from './PendingRequestsSection';

export interface AIChangeDetailExtension {
  /** Stable React key. */
  key: string;
  /** Header action, next to "Revert change set…". */
  Action?: ComponentType<{ change: AIChangeDetail }>;
  /** A section after the summary. */
  Section?: ComponentType<{ change: AIChangeDetail }>;
}

export const AI_CHANGE_DETAIL_EXTENSIONS: AIChangeDetailExtension[] = [
  { key: 'mcp-requests', Section: PendingRequestsSection },
];
